import { useState } from "react";
import personalBestBg from "../../Assets/Images/header-background.png";

export default function SkillCard({
  unit,
  backgroundImage,
  gameImage,
  ballerzGameName,
  esaIsHitMiss,
  hit,
  miss,
  scoreDisplay,
  best,
  previous,
  league,
}) {
  const [expanded, setExpanded] = useState(false);

  return (
    <>
      <div
        className="bg-[#00001d] rounded-md overflow-hidden shadow-lg text-white font-sans"
        onClick={() => setExpanded(!expanded)}
      >
        <div className="relative">
          <div className="h-[10px] w-full bg-[#3F50F6] rounded-t-md"></div>

          <div
            className="h-32 relative z-10 px-4 py-3"
            style={{
              backgroundImage: `url(${backgroundImage})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
            }}
          >
            {/* <a
              onClick={() => alert("Share button clicked!")}
              className="absolute top-3 right-4 flex items-center gap-1 text-white text-sm cursor-pointer"
            >
              Share
              <img
                className="w-4 h-4"
                src={require(`./assets/share.png`)}
                alt="share icon"
              />
            </a> */}

            <svg
              viewBox="0 0 100 40"
              preserveAspectRatio="none"
              className="absolute bottom-0 left-0 w-[40%] h-[40px] text-[#00001d]"
            >
              <path d="M0,0 C100,0 60,40 100,40 L0,40 Z" fill="currentColor" />
            </svg>
          </div>
        </div>

        <div className="h-[100px] flex items-start justify-between bg-[#00001d] px-4 relative overflow-visible">
          <div className="text-left max-w-[55%] mt-2">
            <div className="text-sm font-bold tracking-wide leading-tight">
              <img
                className="w-[45%] h-[45%] object-contain"
                src={gameImage}
                alt="logo"
              />
            </div>

            <div
              className={`text-xs text-[#4F83FF] uppercase mb-2 ${
                ballerzGameName === "Basket" ||
                gameImage ===
                  "https://app.ballerz.co.uk/assets/portal/icon/tiki-taka.png"
                  ? "mt-2"
                  : gameImage ===
                    "https://app.ballerz.co.uk/assets/portal/icon/sharpshooter.png"
                  ? "mt-0"
                  : "mt-6"
              } Kallisto_Bold`}
            >
              {ballerzGameName}
            </div>
          </div>

          <div className="text-right relative z-10">
            <div className="text-sm sm:text-xs text-orange-400 flex items-center gap-1 sm:gap-2 justify-end relative z-10">
              <span className="uppercase Kallisto_Bold">{unit}</span>
            </div>

            {esaIsHitMiss === 0 ? (
              <div className="absolute -top-10 right-0 text-9xl font-extrabold leading-none DrukWideMediumItalic">
                {best.scoreDisplay}
              </div>
            ) : (
              <>
                <div
                  className="absolute -top-10 right-20 text-9xl font-extrabold leading-none DrukWideMediumItalic"
                  style={{
                    WebkitTextStroke: "2px green",
                    color: "white",
                  }}
                >
                  {best.hit}
                </div>
                <div
                  className="absolute -top-10 right-0 text-9xl font-extrabold leading-none DrukWideMediumItalic"
                  style={{
                    WebkitTextStroke: "2px red",
                    color: "white",
                  }}
                >
                  {best.miss}
                </div>
              </>
            )}
          </div>
        </div>

        <div
          className="relative text-white px-4 py-2 text-sm flex justify-between items-center rounded-b-lg font-medium tracking-wide overflow-hidden"
          style={{
            backgroundImage: `url(${personalBestBg})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        >
          <div className="absolute inset-0 bg-[#3F50F6] opacity-80 pointer-events-none"></div>

          <div className="relative flex justify-between items-center w-full">
            <div className="w-[15%] flex items-center justify-start">
              <img
                className="w-3 h-3 sm:w-4 sm:h-4 object-contain"
                src={require(`./assets/trophey.png`)}
                alt="trophy"
              />
            </div>

            {/* <div className="w-[60%] text-left text-xl uppercase Kallisto_Bold">
              {best.username}
            </div> */}

            <div className="w-[60%] text-left text-xl uppercase Kallisto_Bold truncate">
              {best.username}
            </div>

            <div className="w-[25%] text-right text-2xl font-extrabold italic Kallisto_Bold">
              {best.scoreDisplay}
            </div>
          </div>
        </div>

        <div className="bg-[#00001d] px-4 py-4 text-sm space-y-3 Kallisto_Bold">
          {league?.map((league, index) => (
            <div
              key={index}
              className="flex justify-between items-center text-white font-medium"
            >
              <div className="w-[15%] uppercase text-xs font-bold">
                {league.scoreDisplay === best.scoreDisplay ? (
                  <img
                    className="w-3 h-3 sm:w-4 sm:h-4 object-contain"
                    src={require(`./assets/trophey.png`)}
                    alt="trophy"
                  />
                ) : (
                  <>{league.position}</>
                )}
              </div>
              <div className="w-[60%] text-left">{league.username}</div>
              <div className="w-[25%] text-right text-2xl font-extrabold italic Kallisto_Bold">
                {league.scoreDisplay}
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
}
